import styled from 'styled-components';
import { formatViewport } from 'utils/get-pixels-to-viewport';

export const WidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2%;
  height: 100%;
  max-height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 3%;
  overflow-y: auto;
  width: 100%;

  .loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
  }

  .no-reservations {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
  }

  .amenity-reservations-list-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    width: 100%;
  }

  .amenity-reservations-list-header {
    border-bottom: 1px solid ${({ theme }) => theme.border.primary};
    color: ${({ theme }) => theme.text.primary};
    font-size: ${formatViewport(20)};
    padding: ${formatViewport(7.5)} 0;
  }
`;
